import {CLINICDATA} from '../constants';
const INITIAL_STATE = [];
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case CLINICDATA:
      return action.payload;
    default:
      return state;
  }
}
